/*
 * env.ts
 * These are app environment constants such as where our backend is located, what
 * version of the API we are using, etc
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'YOUR_ACTION_CONSTANT';
 */

const IS_DEV = typeof __DEV__ !== 'undefined' ? __DEV__ : false;
const IS_PROD = typeof __PROD__ !== 'undefined' ? __PROD__ : false;
const IS_STAGING = typeof __STAGING__ !== 'undefined' ? __STAGING__ : false;
const IS_STAGING_DEBUG = typeof __STAGING_DEBUG__ !== 'undefined' ? __STAGING_DEBUG__ : false;
const IS_INTEGRATION = typeof __INTEGRATION__ !== 'undefined' ? __INTEGRATION__ : false;

let apiUrl = '';

let flagsConfig = {};
let stripePublishableKey = ''; // Publishable Keys are not priviledged secret keys
let intercomAppID = '';
let sentrySampleRate = 0;
const sentryTracingOrigins: (string | RegExp)[] = ['localhost']; // replicate Sentry's defaults of ['localhost', '^\\/']
let googleMapsApiKey = '';
let mixpanelApiKey = '';
let mixpanelDebugMode = false;
let mixpanelTestMode = false;
let sentryEnv = '';
let frontendDomain = '';

if (IS_DEV) {
  flagsConfig = {
    appName: 'development',
    host: 'https://gitlab.com/api/v4',
    uri: '/feature_flags/unleash/24698743/client/features',
    instanceId: 'dZkdEFxCyodnePYDW6Y-',
  };
  stripePublishableKey = 'pk_test_jG4cQfE2KxSgAgBhmmlojYLM';
  intercomAppID = 'lgu962la';
  apiUrl = `http://${window.location.hostname}:8000`;
  googleMapsApiKey = 'AIzaSyBmh_y_1i0ypuXysTJ7NkH0NGFsqWz9hyM';
  mixpanelApiKey = 'f4623606a74e94ac07769cf971bddf3b';
  mixpanelDebugMode = true;
  sentryEnv = 'development';
  frontendDomain = 'localhost:3000';
} else if (IS_STAGING || IS_STAGING_DEBUG) {
  flagsConfig = {
    appName: 'staging',
    host: 'https://gitlab.com/api/v4',
    uri: '/feature_flags/unleash/24698743/client/features',
    instanceId: 'dZkdEFxCyodnePYDW6Y-',
  };
  stripePublishableKey = 'pk_test_jG4cQfE2KxSgAgBhmmlojYLM';
  intercomAppID = 'lgu962la';
  apiUrl = 'https://api.fleetlane.dev';
  sentrySampleRate = 0.01; // TODO(GREG): review if this is enough for testing purposes
  googleMapsApiKey = 'AIzaSyAMCj5c6pyWE_wQibcvARwlyOZoBxUjnd8';
  mixpanelApiKey = '0c2e35faedfa2a2eea8daf5d261df11d';
  sentryEnv = 'staging';
  frontendDomain = 'fleetlane.dev';
} else if (IS_PROD) {
  flagsConfig = {
    appName: 'production',
    host: 'https://gitlab.com/api/v4',
    uri: '/feature_flags/unleash/24698743/client/features',
    instanceId: 'dZkdEFxCyodnePYDW6Y-',
  };
  stripePublishableKey = 'pk_live_9yZSQIrDy82yX6Dc2VfkikFo';
  intercomAppID = 'dkjl0sn9';
  apiUrl = 'https://api.fleetlane.com';
  sentrySampleRate = 0.05; // Should allow us to stay below our current limit of 2 Transaction/min
  googleMapsApiKey = 'AIzaSyAMCj5c6pyWE_wQibcvARwlyOZoBxUjnd8';
  mixpanelApiKey = 'ff7c5d41c4e7c402963fdf417f94eb9f';
  sentryEnv = 'production';
  frontendDomain = 'fleetlane.com';
} else {
  // Testing
  flagsConfig = {
    appName: 'tests',
    host: 'http://localhost',
    uri: '/feature_flags/features',
    instanceId: 'testInstance-',
  };
  stripePublishableKey = 'pk_test_jG4cQfE2KxSgAgBhmmlojYLM';
  intercomAppID = 'lgu962la';
  apiUrl = `http://localhost:8000`;
  googleMapsApiKey = 'AIzaSyBmh_y_1i0ypuXysTJ7NkH0NGFsqWz9hyM';
  mixpanelApiKey = '';
  mixpanelDebugMode = true;
  mixpanelTestMode = true;
  sentryEnv = 'testing';
  frontendDomain = 'fleetlane.test';
}

sentryTracingOrigins.push(apiUrl);

export const INTERCOM_APP_ID = intercomAppID;
export const STRIPE_API_KEY = stripePublishableKey;
export const SENTRY_DSN = 'https://3f8a16fba3c6498f95ce4e22c0454948@o54051.ingest.sentry.io/1205255';
export const SENTRY_SAMPLE_RATE = sentrySampleRate;
export const SENTRY_TRACING_ORIGINS = sentryTracingOrigins;
export const API_URL = apiUrl;
export const API_VER = '/api/v1/';
export const FLAG_CONFIG = flagsConfig;
export const GOOGLE_MAPS_API_KEY = googleMapsApiKey;
export const MIXPANEL_API_KEY = mixpanelApiKey;
export const MIXPANEL_DEBUG = mixpanelDebugMode;
export const MIXPANEL_TEST = mixpanelTestMode;
export const SENTRY_ENV = sentryEnv;
export const FRONTEND_DOMAIN = frontendDomain;
